import { render, staticRenderFns } from "./product-ranking-element-aside.component.vue?vue&type=template&id=428a6fb9&scoped=true"
import script from "./product-ranking-element-aside.component.vue?vue&type=script&lang=ts"
export * from "./product-ranking-element-aside.component.vue?vue&type=script&lang=ts"
import style0 from "./product-ranking-element-aside.component.vue?vue&type=style&index=0&id=428a6fb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a6fb9",
  null
  
)

export default component.exports